module.exports = __webpack_public_path__ + "static/media/Brakes-white.f8f92ca9.svg";